import React from 'react';
import PropTypes from 'prop-types';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';
import Card from '@spotahome/landings-common/src/components/Card';
import './WhySpotAHome.scss';

const WhySpotAHome = props => {
  const handleClickTenant = () => {
    Metrics.ga.sendEvent(
      'info_tenants_referred',
      'tenants_referred_button',
      'click_tenants_referred_info_button'
    );
    props.onProfileChoice({ isTenant: true, isLandlord: false });
  };

  const handleClickLandlord = () => {
    Metrics.ga.sendEvent(
      'info_landlords_referred',
      'landlord_referred_button',
      'click_landlords_referred_info_button'
    );
    props.onProfileChoice({ isTenant: false, isLandlord: true });
  };

  const cardsContent = [
    {
      image: '/images/referee/tenant.png',
      alt: 'tenant',
      title: 'referee.wsah.tenant.title',
      textFirst: 'referee.wsah.tenant.first.text',
      textSecond: 'referee.wsah.tenant.second.text',
      textThird: 'referee.wsah.tenant.third.text',
      callToActionText: 'referee.wsah.tenant.btn',
      action: handleClickTenant,
      dataTest: 'card-wsah-tenant'
    },
    {
      image: '/images/referee/landlady_1.jpg',
      alt: 'landlady',
      title: 'referee.wsah.landlord.title',
      textFirst: 'referee.wsah.landlord.first.text',
      textSecond: 'referee.wsah.landlord.second.text',
      textThird: 'referee.wsah.landlord.third.text',
      callToActionText: 'referee.wsah.landlord.btn',
      action: handleClickLandlord,
      dataTest: 'card-wsah-landlord'
    }
  ];

  const renderCards = card => (
    <Card
      key={card.title}
      image={getResourcePath(card.image)}
      alt={card.alt}
      cardTitle={trans(card.title)}
      callToActionText={card.callToActionText}
      onClick={() => card.action()}
      dataTest={card.dataTest}
    >
      <p className="card__text">{trans(card.textFirst)}</p>
      <p className="card__text">{trans(card.textSecond)}</p>
      <p className="card__text">{trans(card.textThird)}</p>
    </Card>
  );

  return (
    <section className="wsah__section">
      <SectionHeading text={trans('referee.wsah.title')} />
      <div className="wsah__wrapper">
        {cardsContent.map(card => renderCards(card))}
      </div>
    </section>
  );
};

WhySpotAHome.propTypes = { onProfileChoice: PropTypes.func.isRequired };

export default WhySpotAHome;
